// extracted by mini-css-extract-plugin
export default {"actions":"confirm-modal_actions__+2ien"};